import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { getAwsRegion, getCognitoConfig, getMonitoringConfig } from '../../utils/environmentUtils';

const DEFAULT_CONFIG: Partial<AwsRumConfig> = {
  sessionSampleRate: 1,
  allowCookies: true,
  enableXRay: true,
  enableRumClient: true,
  disableAutoPageView: false,
  pageIdFormat: 'PATH_AND_HASH',
};

export class RumClient {
  private static instance: AwsRum | null = null;

  static initialize(userAlias: string): AwsRum | null {
    if (this.instance) return this.instance;

    try {
      const { rumAppMonitorId } = getMonitoringConfig();
      const { identityPoolId, unAuthRoleARN } = getCognitoConfig();
      const region = getAwsRegion();

      const config: AwsRumConfig = {
        ...DEFAULT_CONFIG,
        guestRoleArn: unAuthRoleARN,
        identityPoolId,
        endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
        telemetries: ['performance', 'errors', 'http'],
      };

      this.instance = new AwsRum(rumAppMonitorId, '1.0.0', region, config);
      this.instance.addSessionAttributes({ userAlias });
      return this.instance;
    } catch (error) {
      console.warn('Failed to initialize RUM client:', error);
      return null;
    }
  }

  static getInstance(): AwsRum | null {
    return this.instance;
  }

  static recordEvent<T extends Record<string, unknown>>(eventName: string, eventData: T): void {
    if (!this.instance) return;
    try {
      this.instance.recordEvent(eventName, eventData);
    } catch (error) {
      console.warn(`Failed to record RUM event ${eventName}:`, error);
    }
  }
}
